export default {
  /**
   *
   * @param state
   * @param payload
   * @param property
   */
  setProperty(state, { payload, property }) {
    state[property] = payload;
  },

  /**
   *
   * @param state
   * @param property
   * @param payload
   */
  setProfileProperty(state, { property, payload }) {
    state.profile.profile[property] = payload;
  },

  /**
   *
   * @param state
   * @param property
   * @param payload
   */
  setConfigProperty(state, { property, payload }) {
    state.config[property] = payload;
  },
};
